import ApiConfigs from '../../../configs/AppConfigs';

export default {
  PolicyPOST(_apiname, _apiParam) {
    return new Promise((resolve, reject) => {
      // let apiURL = ApiConfigs.HOST_URL + _apiname;
      let apiURL = _apiname;
      let customHeader = {
        Accept: 'application/json',
        Product: 'Customer-App',
        'Content-Type': 'application/json',
        apikey: 'u9iPpKB4AArC7feZh1EEoB9zpxQz1Ixm',
        client_id: ApiConfigs.POLICY_CLIENTID,
        client_secret: ApiConfigs.POLICY_CLIENTSECRET,
      };
      fetch(apiURL, {
        method: 'POST',
        headers: customHeader,
        body: JSON.stringify(_apiParam),
      }).then(function (response) {
        let status = response.status;
        if (response.status >= 200 && response.status < 300) {
          if (response.headers.get('Content-Type') != null) {
            if (
              response.headers.get('Content-Type') == 'text/plain;charset=UTF-8'
            ) {
              return resolve(response);
            } else {
              return resolve(response.json());
            }
          } else {
            return resolve(response.blob());
          }
        } else if (response.status == 401) {
          return resolve({ notFound: true });
        } else {
          if (
            response.headers.get('Content-Type') != null &&
            response.headers.get('Content-Type') ===
            'application/json;charset=UTF-8'
          ) {
            return reject(response.json());
          } else if (response.headers.get('Content-Type') != null) {
            return reject(response);
          } else {
            return reject(response.blob());
          }
        }
      });
    });
  },

  PolicyGET(method, isConfigCall = false) {
    // let apiURL = ApiConfigs.HOST_URL + method;
    let apiURL = method;
    var authCode = ApiConfigs.AUTH_CODE;
    let customHeader = {
      Accept: 'application/json',
      Product: 'Customer-App',
      'Content-Type': 'application/json',
      apikey: ApiConfigs.ACCESS_TOKEN,
    };
    //if (isConfigCall == false && authCode != "") {
    customHeader['Authorization'] = 'Bearer ' + authCode;
    //}
    return fetch(apiURL, {
      method: 'GET',
      headers: customHeader,
    }).then(function (response) {
      let status = response.status;
      if (response.status >= 200 && response.status < 300) {
        if (response.headers.get('Content-Type') != null)
          if (
            response.headers.get('Content-Type') == 'text/plain;charset=UTF-8'
          ) {
            return Promise.resolve(response);
          } else {
            return Promise.resolve(response.json());
          }
        else {
          return Promise.resolve(response.blob());
        }
      } else {
        if (response.headers.get('Content-Type') != null) {
          return Promise.reject(response.json());
        } else {
          return Promise.reject(response.blob());
        }
      }
    });
  },

  //====Function refreshPOST call for refreshToken API in case of Safeco=======//
  refreshPOST(_apiname, _apiParam) {
    return new Promise((resolve, reject) => {
      let apiURL = _apiname;
      var authCode = _apiParam.accessToken;
      let customHeader = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        //apikey: ApiConfigs.ACCESS_TOKEN,
      };
      if (authCode != '') {
        customHeader['Authorization'] = 'Bearer ' + authCode;
      }
      fetch(apiURL, {
        method: 'POST',
        headers: customHeader,
        body: JSON.stringify(_apiParam),
      }).then(function (response) {
        let status = response.status;
        if (response.status >= 200 && response.status < 300) {
          if (response.headers.get('Content-Type') != null) {
            if (
              response.headers.get('Content-Type') == 'text/plain;charset=UTF-8'
            ) {
              return resolve(response);
            } else {
              return resolve(response.json());
            }
          } else {
            return resolve(response.blob());
          }
        } else if (response.status == 401) {
          return resolve({ notFound: true });
        } else {
          if (
            response.headers.get('Content-Type') != null &&
            response.headers.get('Content-Type') ===
            'application/json;charset=UTF-8'
          ) {
            return reject(response.json());
          } else if (response.headers.get('Content-Type') != null) {
            return reject(response);
          } else {
            return reject(response.blob());
          }
        }
      });
    });
  },

  validatePost(_apiname, _apiParam) {
    return new Promise((resolve, reject) => {
      let apiURL = _apiname;
      var authCode = _apiParam.accessToken;
      let customHeader = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        //apikey: ApiConfigs.ACCESS_TOKEN,
      };
      if (authCode != '') {
        customHeader['Authorization'] = 'Bearer ' + authCode;
      }
      fetch(apiURL, {
        method: 'POST',
        headers: customHeader,
        body: JSON.stringify(_apiParam),
      }).then(function (response) {
        let status = response.status;
        if (response.status >= 200 && response.status < 300) {
          if (response.headers.get('Content-Type') != null) {
            if (
              response.headers.get('Content-Type') == 'text/plain;charset=UTF-8'
            ) {
              return resolve(response);
            } else {
              return resolve(response.json());
            }
          } else {
            return resolve(response.blob());
          }
        } else if (response.status == 401) {
          response.json().then((resp) => {
            let errorText;
            errorText = resp.error;
            return resolve({ notFound: true, error: errorText });
          });
        } else {
          if (
            response.headers.get('Content-Type') != null &&
            response.headers.get('Content-Type') ===
            'application/json;charset=UTF-8'
          ) {
            return reject(response.json());
          } else if (response.headers.get('Content-Type') != null) {
            return reject(response);
          } else {
            return reject(response.blob());
          }
        }
      });
    });
  },
  customerSearch(_apiname, _apiParam) {
    return new Promise((resolve, reject) => {
      let apiURL = _apiname;
      var authCode = _apiParam.accessToken;
      let customHeader = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        //apikey: ApiConfigs.ACCESS_TOKEN,
      };
      if (authCode != '') {
        customHeader['Authorization'] = 'Bearer ' + authCode;
      }
      delete _apiParam.accessToken;
      fetch(apiURL, {
        method: 'POST',
        headers: customHeader,
        body: JSON.stringify(_apiParam),
      }).then(function (response) {
        let status = response.status;
        if (response.status >= 200 && response.status < 300) {
          if (response.headers.get('Content-Type') != null) {
            if (
              response.headers.get('Content-Type') == 'text/plain;charset=UTF-8'
            ) {
              return resolve(response);
            } else {
              return resolve(response.json());
            }
          } else {
            return resolve(response.blob());
          }
        } else if (response.status == 401) {
          return resolve({ notFound: true });
        } else {
          if (
            response.headers.get('Content-Type') != null &&
            response.headers.get('Content-Type') ===
            'application/json;charset=UTF-8'
          ) {
            return reject(response.json());
          } else if (response.headers.get('Content-Type') != null) {
            return reject(response);
          } else {
            return reject(response.blob());
          }
        }
      });
    });
  },
  POST(_apiname, _apiParam) {
    return new Promise((resolve, reject) => {
      let apiURL = ApiConfigs.HOST_URL + _apiname;
      var authCode = ApiConfigs.AUTH_CODE;
      let customHeader = {
        Accept: 'application/json',
        Product: 'Customer-App',
        'Content-Type': 'application/json',
        //apikey: ApiConfigs.ACCESS_TOKEN,
      };
      if (authCode != '') {
        customHeader['Authorization'] = 'Bearer ' + authCode;
      }
      fetch(apiURL, {
        method: 'POST',
        headers: customHeader,
        body: JSON.stringify(_apiParam),
      }).then(function (response) {
        let status = response.status;
        if (response.status >= 200 && response.status < 300) {
          if (response.headers.get('Content-Type') != null)
            return resolve(response.json());
          else {
            return resolve(response.blob());
          }
        } else {
          if (
            response.headers.get('Content-Type') != null &&
            response.headers.get('Content-Type') ===
            'application/json;charset=UTF-8'
          ) {
            return reject(response.json());
          } else if (response.headers.get('Content-Type') != null) {
            return reject(response);
          } else {
            return reject(response.blob());
          }
        }
      });
    });
  },

  GET(method, isConfigCall = false) {
    let apiURL = ApiConfigs.HOST_URL + method;
    var authCode = ApiConfigs.AUTH_CODE;
    let customHeader = {
      Accept: 'application/json',
      Product: 'Customer-App',
      'Content-Type': 'application/json',
      //"auth-token": ApiConfigs.ACCESS_TOKEN,
    };
    if (isConfigCall == false && authCode != '') {
      customHeader['Authorization'] = 'Bearer ' + authCode;
    }
    return fetch(apiURL, {
      method: 'GET',
      headers: customHeader,
    }).then(function (response) {
      let status = response.status;
      if (response.status >= 200 && response.status < 300) {
        if (response.headers.get('Content-Type') != null)
          if (
            response.headers.get('Content-Type') == 'text/plain;charset=UTF-8'
          ) {
            return Promise.resolve(response);
          } else {
            return Promise.resolve(response.json());
          }
        else {
          return Promise.resolve(response.blob());
        }
      } else {
        if (response.headers.get('Content-Type') != null) {
          return reject(response.json());
        } else {
          return reject(response.blob());
        }
      }
    });
  },

  PUT(method, _apiParam) {
    let apiURL = ApiConfigs.HOST_URL + method;
    var authCode = ApiConfigs.AUTH_CODE;
    let customHeader = {
      Accept: 'application/json',
      Product: 'Customer-App',
      'Content-Type': 'application/json',
      //apikey: ApiConfigs.ACCESS_TOKEN
    };
    if (authCode != '') {
      customHeader['Authorization'] = 'Bearer ' + authCode;
    }
    return fetch(apiURL, {
      method: 'PUT',
      headers: customHeader,
      body: JSON.stringify(_apiParam),
    }).then(function (response) {
      let status = response.status;
      if (response.status >= 200 && response.status < 300) {
        if (response.headers.get('Content-Type') != null)
          return Promise.resolve(response.json());
        else {
          return Promise.resolve(response.blob());
        }
      } else {
        if (response.headers.get('Content-Type') != null) {
          return reject(response.json());
        } else {
          return reject(response.blob());
        }
      }
    });
  },
};
